<template>
  <div class="reimbursement-requests">
    <alert-box
      v-for="alert in alerts"
      :key="alert.message"
      :type="alert.type"
    >
      {{ alert.message }}
    </alert-box>
    <div class="container">
      <div
        v-if="loading"
        class="row loading"
      >
        <img
          v-if="loading"
          :src="loadingImageUrl"
          alt="loading"
          class="taxon-loading-indicator"
        />
      </div>
      <template v-else>
        <div
          v-if="reimbursementRequests.length > 0"
          class="row reimbursement-requests"
        >
          <div class="col-md-12">
            <reimbursement-request-list
              :reimbursement-requests="reimbursementRequests"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import alerts from 'mixins/storefront/cart-alerts'
  import ReimbursementRequestList from "./reimbursement-request/list";

  export default {
    components: {
      ReimbursementRequestList
    },
    mixins: [alerts],
    props: {
      reimbursementRequestsPath: {
        type: String,
        required: true,
      },
      loadingImageUrl: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        loading: true,
        orders: [],
        reimbursementRequests: [],
      };
    },
    created() {
      axios
        .get(this.reimbursementRequestsPath)
        .then((response) => {
          switch (response.status) {
            case 200:
              this.orders = response.data.returnable_orders;
              this.reimbursementRequests = response.data.reimbursement_requests;
              break;
            case 422:
              response.data.errors.forEach((error) => {
                this.alert(error, 'danger');
              });
              break;
            default:
              break;
          }
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            error.response.data.errors.forEach((message) => {
              this.alert(message, "danger")
            })
          } else {
            this.alert(error.message || error, "danger")
          }
        }).finally(() => {
          this.loading = false;
        });
    },
  };
</script>
